<template>
    <v-card flat class="grey lighten-4">
        <v-card-text class="text-body-1 d-flex align-center">
            <b v-if="userInfo.sf_user_type === tableUserModes.SERVICE">Service</b>
            <b v-else>User</b>
            <v-spacer></v-spacer>
            <v-btn color="primary" @click="switchUserMode()" :loading="settingTableUserMode" class="ml-6">Switch mode</v-btn>
        </v-card-text>
    </v-card>
</template>

<script>
import { mapState } from 'vuex'
import { enumsData } from '@/mixins/enums'

export default {
    name: 'TableUserModeSwitch',
    mixins: [enumsData],
    data() {
        return {
            selectedUserMode: -1
        }
    },
    computed: {
        ...mapState(['userInfo']),
        ...mapState('userStore', ['settingTableUserMode'])
    },
    methods: {
        async switchUserMode() {
            this.selectedUserMode = this.selectedUserMode === this.tableUserModes.SERVICE ? this.tableUserModes.USER : this.tableUserModes.SERVICE
            this.$store.dispatch('userStore/setTableUserMode', this.selectedUserMode)
        }
    },
    watch: {
        userInfo: {
            handler(info) {
                if (info.sf_user_type === this.tableUserModes.NONE) return

                switch (info.sf_user_type) {
                    case this.tableUserModes.SERVICE:
                        this.selectedUserMode = this.tableUserModes.SERVICE
                        break
                    case this.tableUserModes.USER:
                    case this.tableUserModes.LEGACY:
                        this.selectedUserMode = this.tableUserModes.USER
                        break
                    default:
                        break
                }
            },
            immediate: true
        }
    }
}
</script>
